for (var i = 0; i < stores.length; i++) {
  if (!stores[i]) continue;
  var storeName = stores[i].name.toLowerCase();
  var storeId = stores[i].storeID;

  if ((specialProduct1 === true) ) {
    if (storeId !== 5306 ) {
        delete stores[i];
    }
  }
}